module.exports = {
  CPF: require("./lib/cpf"),
  CNPJ: require("./lib/cnpj")
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/cpf_cnpj/index.js
// module id = 713
// module chunks = 0